/**
 * Tutorial analytics helper.
 *
 * We deliberately reuse the existing chat analytics endpoint
 * (`/api/property/chat/analytics`) instead of introducing a new
 * analytics provider — as required by the spec. Events are namespaced
 * with the reserved `__tutorial__` property key so admin dashboards
 * can filter tutorial-related events cleanly.
 *
 * `keepalive: true` lets the event survive an immediate navigation
 * (e.g. when the user taps the "Analyze a Property" CTA from inside
 * the tutorial modal and jumps to /analyze).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TUTORIAL_KEY = '__tutorial__';

export const TUTORIAL_EVENTS = {
  STARTED: 'tutorial_started',
  COMPLETED: 'tutorial_completed',
  SKIPPED: 'tutorial_skipped',
  REPLAYED: 'tutorial_replayed',
  CTA_ANALYZE: 'tutorial_cta_analyze_clicked',
};

export function fireTutorialEvent(event, meta = {}) {
  try {
    fetch(`${BACKEND_URL}/api/property/chat/analytics`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, property_key: TUTORIAL_KEY, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Analytics must never break UX.
  }
}
